<template>
  <div
    class="flex flex-col gap-3"
  >
    <div>
      Recent Order Status:
      <p class="text-2xl font-semibold">
        {{ title }}
      </p>
      <p v-if="failure">
        Please Call Customer Service: 999.999.9999
      </p>
    </div>
    <MalomoMap v-bind="{ shipment }" />

    
    <div class="flex flex-col gap-1">
      <p>Order {{ order.name }}</p>
      <p>Order Date: {{ formatDateTime(order.created_at) }}</p>
      <div
        v-if="status === 'in_transit' && shipment.estimated_delivery_date"
        class="flex flex-col"
      >
        <p>Estimated Delivery</p>
        <p class="text-2xl font-semibold">
          {{ format(new Date(shipment.estimated_delivery_date), 'EEEE, MMMM d') }}
        </p>
      </div>
      <div class="flex flex-col">
        <p>Latest activity</p>
        <p class="font-semibold">
          {{ format(new Date(shipment.scan_events[0].scanned_at), 'MMMM d p') }}
        </p>
        <p>{{ shipment.scan_events[0].message }}</p>
      </div>
      <div class="flex flex-col">
        <p>{{ shipment.carrier_name }}</p>
        <div class="flex gap-3">
          <a
            class="text-blue-400 font-semibold"
            :href="shipment.carrier_url"
            target="_blank"
          >{{ shipment.tracking_code }}</a>
          <button @click="copyTrackingCode">
            <svg-icon
              name="copy"
              class="h-4 w-4 text-blue-400"
            />
          </button>

        </div>
      </div>
      <button
        class="button border-green-500 text-green-500"
        @click="modalActive = true"
      >
        Show History
      </button>
    </div>
    <VueModal
      v-model="modalActive"
      @close="modalActive = false"
    >
      <MalomoHistoryModal
        :shipment="shipment"
        @close="modalActive = false"
      />
    </VueModal>
  </div>
</template>

<script setup lang="ts">
import { format } from 'date-fns'
import type { Shipment, MalomoOrder } from '@/types'
import { ref } from 'vue'
import { formatDateTime } from '@/utils'
import MalomoMap from './malomo-map.vue'
import VueModal from './vue-modal.vue'
import MalomoHistoryModal from './malomo-history-modal.vue'
import { useToastStore } from '@/plugins/toast'

export interface Props {
  order: MalomoOrder
  shipment: Shipment
}

const { alert } = useToastStore()

const props = defineProps<Props>()

const StatusMap: Map<Shipment['status'], string> = new Map([
  [ 'unknown', 'Packing Your Order 🙌' ],
  [ 'pre_transit', 'Packing Your Order 🙌' ],
  [ 'in_transit', 'On the Way 📦' ],
  [ 'out_for_delivery', 'Out for Delivery 🚚' ],
  [ 'delivered', 'Delivered 🎉' ],
  [ 'available_for_pickup', 'Available for Pickup 🙌' ],
  [ 'return_to_sender', 'Something’s Not Right 🤔' ],
  [ 'failure', 'Something’s Not Right 🤔' ],
  [ 'cancelled', 'Cancelled' ],
  [ 'error', 'Something’s Not Right 🤔' ]
])

const status = props.shipment.status
const failure = status === 'return_to_sender' || status === 'failure' || status === 'error'
const title = StatusMap.get(status)

const modalActive = ref(false)

const copyTrackingCode = async () => {
  await navigator.clipboard.writeText(props.shipment.tracking_code)
  alert('Tracking Code Copied!')
}
</script>
